export default [
	{
		path: '/',
		component: require('../components/HomePage.vue').default,
		meta: {
			helpScreenId: 'cwp_studenthome',
		},
		name:'HomePage'
	},
	{
		path: '/parent-home',
		component: require('../components/HomePage.vue').default,
		meta: {
			helpScreenId: 'cwp_parenthome',
		},
		name: 'ParentHome'
	},
	{
		path: '/debug',
		component: require('../components/developerTools/Debug.vue').default,
		name:'debug'
	},
	{
		path: '/error-logs',
		component: require('../components/developerTools/ErrorLogs.vue').default,
		name: 'ErrorLogs'
	},
	{
		path: '/courses-grades',
		component: require( "../components/CoursesAndGrades/CoursesGradesList.vue" ).default,
		meta: {
			helpScreenId: 'cwp_studclasses',
		},
		name: 'CoursesGrades'
	},
	{
		path: '/class-pages/:courseSectionGUID/grades-breakdown',
		component: require( '../components/classPage/Grades.vue' ).default,
		meta: {
			helpScreenId: 'cwp_classgrades',
		},
		name: 'ClassPageGradesBreakdown'
	},
	{
		path: '/class-pages/:courseSectionGUID/sections/:folderId/sub-pages/:lineNo',
		component:  require( '../components/classPage/Subpage.vue' ).default,
		meta: {
			helpScreenId: 'cwp_classpageitem',
		},
		name: 'ClassPageSectionSubpage'
	},
	{
		path: '/class-pages/:courseSectionGUID/students/:studentRid/sub-pages/:lineNo',
		component: require( '../components/classPage/Subpage.vue' ).default,
		meta: {
			helpScreenId: 'cwp_classpageitem',
		},
		name: 'ClassPageStudentSubpage'
	},
	{
		path: '/class-pages/:courseSectionGUID/student-groups/:groupId/sub-pages/:lineNo',
		component:  require( '../components/classPage/Subpage.vue' ).default,
		meta: {
			helpScreenId: 'cwp_classpageitem',
		},
		name: 'ClassPageGroupSubpage'
	},
	{
		path: '/class-pages/:courseSectionGUID/sub-pages/:lineNo',
		component: require( '../components/classPage/Subpage.vue' ).default,
		meta: {
			helpScreenId: 'cwp_classpageitem',
		},
		name: 'ClassPageSubpage'
	},
	{
		path: '/class-pages/:courseSectionGUID/sections/:folderId/forums/:forumId',
		component: require( '../components/classPage/Forum.vue' ).default,
		meta: {
			helpScreenId: 'cwp_studentclassforumtopics',
		},
		name: 'ClassPageSectionForum'
	},
	{
		path: '/class-pages/:courseSectionGUID/students/:studentRid/forums/:forumId',
		component: require( '../components/classPage/Forum.vue' ).default,
		meta: {
			helpScreenId: 'cwp_studentclassforumtopics',
		},
		name: 'ClassPageStudentForum'
	},
	{
		path: '/class-pages/:courseSectionGUID/student-groups/:groupId/forums/:forumId',
		component: require( '../components/classPage/Forum.vue' ).default,
		meta: {
			helpScreenId: 'cwp_studentclassforumtopics',
		},
		name: 'ClassPageGroupForum'
	},
	{
		path: '/class-pages/:courseSectionGUID/forums/:forumId',
		component: require( '../components/classPage/Forum.vue' ).default,
		meta: {
			helpScreenId: 'cwp_studentclassforumtopics',
		},
		name: 'ClassPageForum'
	},
	{
		path: '/class-pages/:courseSectionGUID/sections/:folderId/forums/:forumId/topics/:topicId',
		component: require( '../components/classPage/Post.vue' ).default, 
		meta: {
			helpScreenId: 'cwp_classdormposts',
		},
		name: 'ClassPageSectionForumPost'
	},
	{
		path: '/class-pages/:courseSectionGUID/students/:studentRid/forums/:forumId/topics/:topicId',
		component: require( '../components/classPage/Post.vue' ).default,
		meta: {
			helpScreenId: 'cwp_classdormposts',
		},
		name: 'ClassPageStudentForumPost'
	},
	{
		path: '/class-pages/:courseSectionGUID/student-groups/:groupId/forums/:forumId/topics/:topicId',
		component: require( '../components/classPage/Post.vue' ).default,
		meta: {
			helpScreenId: 'cwp_classdormposts',
		},
		name: 'ClassPageGroupForumPost'
	},
	{
		path: '/class-pages/:courseSectionGUID/forums/:forumId/topics/:topicId',
		component: require( '../components/classPage/Post.vue' ).default,
		meta: {
			helpScreenId: 'cwp_classdormposts',
		},
		name: 'ClassPageForumPost'
	},
	{
		path: '/class-pages/:courseSectionGUID/sections/:folderId/assignment-bins/:assignmentBinId',
		component: require( '../components/classPage/assignmentBin/AssignmentBin.vue' ).default,
		meta: {
			helpScreenId: 'cwp_classdropbox',
		},
		name: 'ClassPageSectionAssignmentBin'
	},
	{
		path: '/class-pages/:courseSectionGUID/students/:studentRid/assignment-bins/:assignmentBinId',
		component: require( '../components/classPage/assignmentBin/AssignmentBin.vue' ).default,
		meta: {
			helpScreenId: 'cwp_classdropbox',
		},
		name: 'ClassPageStudentAssignmentBin'
	},
	{
		path: '/class-pages/:courseSectionGUID/student-groups/:groupId/assignment-bins/:assignmentBinId',
		component: require( '../components/classPage/assignmentBin/AssignmentBin.vue' ).default,
		meta: {
			helpScreenId: 'cwp_classdropbox',
		},
		name: 'ClassPageGroupAssignmentBin'
	},
	{
		path: '/class-pages/:courseSectionGUID/assignment-bins/:assignmentBinId',
		component: require( '../components/classPage/assignmentBin/AssignmentBin.vue' ).default,
		meta: {
			helpScreenId: 'cwp_classdropbox',
		},
		name: 'ClassPageAssignmentBin'
	},
	{
		path: '/class-pages/:courseSectionGUID/sections/LTILaunch/:lineNo',
		component: require( '../components/classPage/LTILaunch.vue' ).default,
		meta: {
			helpScreenId: 'cwp_studentclasspage',
		},
		name: 'ClassPageLTILaunch'
	},
	{
		path: '/class-pages/:courseSectionGUID/students/:studentRid/LTILaunch/:lineNo',
		component: require( '../components/classPage/LTILaunch.vue' ).default,
		meta: {
			helpScreenId: 'cwp_studentclasspage',
		},
		name: 'ClassPageStudentLTILaunch'
	},
	{
		path: '/class-pages/:courseSectionGUID/student-groups/:groupId/LTILaunch/:lineNo',
		component: require( '../components/classPage/LTILaunch.vue' ).default,
		meta: {
			helpScreenId: 'cwp_studentclasspage',
		},
		name: 'ClassPageGroupLTILaunch'
	},
	{
		path: '/class-pages/:courseSectionGUID/sections/:folderId/assignment-bins/:assignmentBinId/assignments/:assignmentId/submissions',
		component: require( '../components/classPage/assignmentBin/Submission.vue' ).default,
		meta: {
			helpScreenId: 'cwp_dbsubmissions',
		},
		name: 'ClassPageSectionAssignmentBinSubmission'
	},
	{
		path: '/class-pages/:courseSectionGUID/students/:studentRid/assignment-bins/:assignmentBinId/assignments/:assignmentId/submissions',
		component: require( '../components/classPage/assignmentBin/Submission.vue' ).default,
		meta: {
			helpScreenId: 'cwp_dbsubmissions',
		},
		name: 'ClassPageStudentAssignmentBinSubmission'
	},
	{
		path: '/class-pages/:courseSectionGUID/student-groups/:groupId/assignment-bins/:assignmentBinId/assignments/:assignmentId/submissions',
		component: require( '../components/classPage/assignmentBin/Submission.vue' ).default,
		meta: {
			helpScreenId: 'cwp_dbsubmissions',
		},
		name: 'ClassPageGroupAssignmentBinSubmission'
	},
	{
		path: '/class-pages/:courseSectionGUID/assignment-bins/:assignmentBinId/assignments/:assignmentId/submissions',
		component: require( '../components/classPage/assignmentBin/Submission.vue').default,
		meta: {
			helpScreenId: 'cwp_assignmentfeedback',
		},
		name: 'ClassPageAssignmentBinSubmission'
	},
	{
		path: '/class-pages/:courseSectionGUID/sections/:folderId/assignment-bins/:assignmentBinId/assignments/:assignmentId/feedback',
		component: require( '../components/classPage/assignmentBin/FeedBack.vue').default,
		meta: {
			helpScreenId: 'cwp_assignmentfeedback',
		},
		name: 'ClassPageSectionAssignmentBinFeedback'
	},
	{
		path: '/class-pages/:courseSectionGUID/students/:studentRid/assignment-bins/:assignmentBinId/assignments/:assignmentId/feedback',
		component: require('../components/classPage/assignmentBin/FeedBack.vue').default,
		meta: {
			helpScreenId: 'cwp_assignmentfeedback',
		},
		name: 'ClassPageStudentAssignmentBinFeedback'
	},
	{
		path: '/class-pages/:courseSectionGUID/student-groups/:groupId/assignment-bins/:assignmentBinId/assignments/:assignmentId/feedback',
		component: require( '../components/classPage/assignmentBin/FeedBack.vue').default,
		meta: {
			helpScreenId: 'cwp_assignmentfeedback',
		},
		name: 'ClassPageGroupAssignmentBinFeedback'
	},
	{
		path: '/class-pages/:courseSectionGUID/assignment-bins/:assignmentBinId/assignments/:assignmentId/feedback',
		component: require( '../components/classPage/assignmentBin/FeedBack.vue').default,
		meta: {
			helpScreenId: 'cwp_assignmentfeedback',
		},
		name: 'ClassPageAssignmentBinFeedback'
	},
	{
		path: '/class-pages/:courseSectionGUID/sections/:folderId',
		component: require('../components/classPage/Section.vue').default,
		meta: {
			helpScreenId: 'cwp_studentclasspage',
		},
		name: 'ClassPageSection'
	},
	{
		path: '/class-pages/:courseSectionGUID',
		component: require('../components/classPage/index.vue').default,
		meta: {
			helpScreenId: 'cwp_studentclasspage',
		},
		name: 'ClassPageHome'
	},
	{
		path: '/courses-grades/:courseSectionGUID/glossary/:glossaryType/:glossaryID',
		component:  require('../components/classPage/ClassGlossary.vue').default,
		meta: {
			helpScreenId: 'cwp_classglossary',
		},
		name: 'CoursesGradesGlossary'
	},
	{
		path: '/course-request-forms',
		component:  require( '../components/CourseRequestForms.vue').default,
		meta: {
			helpScreenId: 'cwp_crformchoice',
		},
		name: 'CourseRequestForms'
	},
	{
		path: '/interactive-scheduler',
		component: require('../components/InteractiveScheduler.vue').default,
		meta: {
			helpScreenId: 'cwp_interactivesched',
		},
		name: 'InteractiveScheduler'
	},
	{
		path: '/lunch-menus',
		component: require('../components/LunchMenus.vue').default,
		meta: {
			helpScreenId: 'cwp_lunchmenus',
		},
		name: 'LunchMenus'
	},
	{
		path: '/fees',
		component: require('../components/Fees.vue').default,
		meta: {
			helpScreenId: 'cwp_studentfees',
		},
		name: 'Fees'
	},
	{
		path: '/discipline',
		component: require('../components/Discipline.vue').default,
		meta: {
			helpScreenId: 'cwp_studentdiscipline',
		},
		name: 'Discipline'
	},
	{
		path: '/student-information',
		component: require('../components/studentInformation/StudentInformation.vue').default,
		meta: {
			helpScreenId: 'cwp_studentinfo',
		},
		name: 'StudentInformation'
	},
	{
		path: '/assessment-scores',
		component: require('../components/AssessmentScores.vue').default,
		meta: {
			helpScreenId: 'cwp_assessments',
		},
		name: 'AssessmentScores'
	},
	{
		path: '/assessment-scores/:assessmentTypeRID/assessment/:assessmentRID',
		component: require('../components/AssessmentScoresDetails.vue').default,
		meta: {
			helpScreenId: 'cwp_assessments',
		},
		name: 'AssessmentScores'
	},
	{
		path: '/attendance',
		component: require('../components/Attendance.vue').default,
		meta: {
			helpScreenId: 'cwp_studattendance',
		},
		name: 'Attendance'
	},
	{
		path: '/graduation-progress',
		component: require('../components/graduationProgress/GraduationProgressReport.vue').default,
		meta: {
			helpScreenId: 'cwp_gradprogress',
		},
		name: 'GraduationProgress'
	},
	{
		path: '/file-cabinet',
		component: require('../components/Reports/FileCabinet.vue').default,
		meta: {
			helpScreenId: 'cwp_doccenter',
		},
		name: 'FileCabinet'
	},
	{
		path: '/letters',
		component: require('../components/Reports/ReportFiles.vue').default,
		meta: {
			helpScreenId: 'cwp_letters',
		},
		name: 'Letters'
	},
	{
		path: '/transcript',
		component: require('../components/Reports/ReportFiles.vue').default,
		meta: {
			helpScreenId: 'cwp_transcript',
		},
		name: 'Transcript'
	},
	{
		path: '/progress-reports',
		component: require('../components/Reports/ReportFiles.vue').default,
		meta: {
			helpScreenId: 'cwp_progressreports',
		},
		name: 'ProgressReports'
	},
	{
		path: '/report-cards',
		component: require('../components/Reports/ReportFiles.vue').default,
		meta: {
			helpScreenId: 'cwp_reportcards',
		},
		name: 'ReportCards'
	},
	{
		path: '/account-settings/general',
		component: require('../components/Settings/General.vue').default,
		meta: {
			helpScreenId: 'cwp_accountgeneral',
		},
		name: 'GeneralAccountSettings'
	},
	{
		path: '/account-settings/devices',
		component: require('../components/Settings/Devices.vue').default,
		meta: {
			helpScreenId: 'cwp_accountdevices',
		},
		name: 'DevicesAccountSettings'
	},
	{
		path: '/account-settings/forcePasswordChange',
		component: require('../components/Settings/ForcePasswordChange.vue').default,
		meta: {
			helpScreenId: 'cwp_accountFPass',
		},
		name: 'ForcePasswordChange'
	},
	{
		path: '/account-settings/notifications',
		component: require('../components/Settings/Notifications/Notifications.vue').default,
		meta: {
			helpScreenId: 'cwp_accountnotification',
		},
		name: 'NotificationSettings'
	},
	{
		path: '/account-settings/third-party-access',
		component: require('../components/Settings/ThirdPartyAccess.vue').default,
		meta: {
			helpScreenId: 'cwp_thirdpartyaccess',
		},
		name: 'ThirdPartyAccess'
	},
	{
		path: '/change-student-data',
		component: require('../components/ChangeStudentData/ChangeStudentData.vue').default,
		meta: {
			helpScreenId: 'cwp_studentdataverif',
		},
		name: 'ChangeStudentData'
	},
	{
		path: '/account-settings/students',
		component: require('../components/Settings/Students/Students.vue').default,
		meta: {
			helpScreenId: 'cwp_accountstudents',
		},
		name: 'StudentsSettings'
	},
	{
		path: '/student-data-forms',
		component: require('../components/StudentDataForms.vue').default,
		meta: {
			helpScreenId: 'cwp_studentdataformslist',
		},
		name: 'StudentDataForms'
	},
	{
		path: '/one-time-form/form/:formID/ins/:instanceID',
		component: require('../components/DataForm.vue').default,
		meta: {
			helpScreenId: 'cwp_studentdataverifform',
		},
		name: 'OneTimeForm'
	},
	{
		path: '/on-demand-form/form/:formID/ins/:instanceID',
		component: require('../components/DataForm.vue').default,
		meta: {
			helpScreenId: 'cwp_studentdataverifform',
		},
		name: 'OnDemandForm'
	},
	{
		path: '/on-demand-form/form/:formID/ins/',
		component: require('../components/DataForm.vue').default,
		meta: {
			helpScreenId: 'cwp_studentdataverifform',
		},
		name: 'OnDemandForm'
	},
	{
		path: '/current-schedule',
		component: require('../components/CurrentSchedule/CurrentSchedule.vue').default,
		meta: {
			helpScreenId: 'cwp_studentschedule',
		},
		name: 'CurrentSchedule'
	},
	{
		path: '/student-calendar',
		component: require('../components/StudentCalendar/StudentCalendar.vue').default,
		meta: {
			helpScreenId: 'cwp_calendar',
		},
		name: 'StudentCalendar'
	},
	{
		path: '/testTaker/test/:testRid',
		component: require('../components/testTaker/testTaker.vue').default,
		name: 'testTaker'
	},
	{
		path: '/testReviewer/test/:testRid',
		component: require('../components/testTaker/testReviewer.vue').default,
		name: 'testReviewer'
	},
	{
		path: '/UserWizard/UserConversionWizard',
		component: require('../components/UserWizard/UserConversionWizard.vue').default,
		meta: {
			helpScreenId: 'cwp_account_upg',
		},
		name: 'UserConversionWizard'
	}
];
